export default __webpack_public_path__ + "static/media/mainlogo.a7705748.svg";